module.exports = __webpack_public_path__ + "img/missionaries18_2019_7-7-2021.780ed7d4.jpg";